import { render, staticRenderFns } from "./TournamentList.vue?vue&type=template&id=6ba8dd52&"
import script from "./TournamentList.vue?vue&type=script&lang=js&"
export * from "./TournamentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports